// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WCzt","input":"styles_input__80Nii"};